<template>
  <el-scrollbar ref="scrollbar" class="multiple-table-scroll" @scroll="$emit('table-scroll', $event)">
    <div class="multiple-table">
      <div ref="content" style="width: 100%;" />
      <div v-if="!disabled" class="multiple-table-header">
        <el-checkbox v-if="type === 'selection'" style="margin-right: 15px; color: #333; font-size: 12px;" :value="checked" :indeterminate="indeterminate" @change="chooseAll">{{ $t('common.selectAll') }}</el-checkbox>
        <table-sort v-if="type !== 'none'" :column="column" :sort="sort" @sort-change="$emit('sort-change', $event)" />
      </div>
      <multiple-table
        v-for="(item, index) in list"
        :key="index"
        ref="table"
        class="multiple-table-item"
        :disabled="disabled"
        :type="type"
        :list-prop="listProp"
        :t-index="index"
        :data="item"
        :column="column"
        :child-table="childTable"
        :selection="selection"
        :hide-head="hideHead"
        :hide-table-list="hideTableList"
        :_operation="$operation"
        v-bind="$attrs"
        @choose-item="chooseItem"
      />
      <div v-show="!list.length" class="empty">
        <svg-icon class-name="empty__img" icon-class="default" />
        <p class="empty__desc">{{ $t('common.empty') }}</p>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
import MultipleTable from '@/components/table/multiple-table/multiple-table'
import TableSort from '@/components/table/multiple-table/table-sort'
export default {
  components: {
    MultipleTable,
    TableSort
  },
  props: {
    // eslint-disable-next-line
    $table: {
      type: Object,
      default: () => ({})
    },
    // eslint-disable-next-line
    $operation: {},
    list: {
      type: Array,
      default: () => []
    },
    sort: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selection: []
    }
  },
  computed: {
    listProp() {
      return this.$table._listProp
    },
    hideHead() {
      return this.$table._hideHead
    },
    type() {
      return this.$table._type || 'selection'
    },
    column() {
      return this.$table.column.filter(i => i.prop)
    },
    childTable() {
      return this.$table._table
    },
    checked() {
      return this.selection.length === this.list.length && !!this.list.length
    },
    indeterminate() {
      return !!this.selection.length && !this.checked
    },
    tableScrollWrapper() {
      return this.$refs.scrollbar.$refs.wrap
    },
    tableHeader() {
      return this.$refs.content
    },
    hideTableList() {
      return this.$table._hideTableList
    }
  },
  watch: {
    list() {
      this.selection = []
    },
    selection(val) {
      this.$emit('selection-change', [...val])
    }
  },
  methods: {
    validate(callback) {
      if (!this.$refs.table) return callback(true)
      let total = 0
      let error = 0
      this.$refs.table.forEach((table) => {
        table.validate(i => {
          total = total + 1
          if (!i) error = error + 1
          if (total === this.$refs.table.length) {
            callback(!error)
          }
        })
      })
    },
    toggleRowSelection(row, flag) {
      const index = this.selection.indexOf(row)
      if (flag && index === -1) {
        this.selection.push(row)
      }
      if (!flag && index !== -1) {
        this.selection.splice(index, 1)
      }
    },
    chooseAll(val) {
      if (val) {
        this.selection = [...this.list]
      } else {
        this.selection = []
      }
      this.$emit('select-all', this.selection)
    },
    chooseItem(val, data) {
      const index = this.selection.indexOf(data)
      if (val && index === -1) {
        this.selection.push(data)
      }
      if (!val && index !== -1) {
        this.selection.splice(index, 1)
      }
      this.$emit('select', this.selection, data)
    }
  }
}
</script>

<style lang="scss" scoped>
.multiple-table {
  width: max-content;
  min-width: 100%;
  &-header {
    background: #fff;
    padding: 0 12px;
    /deep/ {
      .el-checkbox__label {
        font-size: 12px;
      }
    }
  }
  .multiple-table-item {
    margin-bottom: 12px;
    &:last-of-type {
      margin: 0;
    }
  }
}
</style>
